import { createAsyncThunk, createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { makeRequest } from 'Douleutaras/services/apiClient';
import { ReduxEntity } from 'Douleutaras/types';
import { RootState } from 'Douleutaras/redux/store';
import { Job } from 'Douleutaras/types/types';
import { Gis } from 'Douleutaras/components/Forms/gis.class';

const JOBS_ENDPOINT = 'api/public/job';

// tslint:disable-next-line:no-any
const jobsEntityAdapter = createEntityAdapter<Job>({
  selectId: item => item.id
});
export const fetchJob = createAsyncThunk(
  'job/get',
  async ({ jobId }: { jobId: number }, api) => {
    const response = await makeRequest(`${JOBS_ENDPOINT}/${jobId}`)(api);

    // This one differentiates the current listing based on tab/page
    const endpointIdentifier = `${JOBS_ENDPOINT}/${jobId}`;
    const resultIds = [response?.data.id];

    return {
      result: response?.data,
      meta: {
        [endpointIdentifier]: resultIds
      }
    };
  }
);

export const sendSupport = createAsyncThunk<{ success: boolean }, { jobId: string; message: string }>(
  'job/support/post',
  async ({ jobId, message }, api) => {
    const response = await makeRequest(`${JOBS_ENDPOINT}/${jobId}/support/`, {
      method: 'POST',
        body: {
        message
        }
    })(api);

    return response.data;
  }
);

// Job for pros
export const jobsSlice = createSlice({
  name: 'jobsV2',
  initialState: jobsEntityAdapter.getInitialState({
    loading: false,
    meta: {}
  } as ReduxEntity<Job>),
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchJob.fulfilled, (state, action) => {
      state.loading = false;
      jobsEntityAdapter.upsertOne(state, action.payload.result);
      state.meta = { ...state.meta, ...action.payload.meta };
    });
    builder.addCase(fetchJob.pending, state => {
      state.loading = true;
    });
  }
});

export const jobSelectors = jobsEntityAdapter.getSelectors((state: RootState) => state.jobsV2);
